var $ = require('jquery')
var Marionette = require('marionette')
var scaleTemplate = require('./../../templates/ScaleItem.html')

module.exports = Marionette.LayoutView.extend({
  tagName: 'li',
  template: scaleTemplate,
  className: 'survey-item survey-item--scale',
  ui: {
    scaleOption: '.js-scale-option'
  },
  events: {
    'click @ui.scaleOption': 'onOptionClick'
  },
  onOptionClick: function (e) {
    var $el = $(e.currentTarget)
    this.ui.scaleOption.removeClass('active')
    $el.toggleClass('active')
    this.trigger(
      'item:value:changed',
      this.getOption('itemIndex'),
      $el.data('optionindex')
    )
  }
})
